module.exports = __webpack_public_path__ + "static/skullsBones-1f9ea5efcab944baf5a75bed80396b8c.png";